import { createFileRoute } from "@tanstack/react-router";
import { Card, Heading } from "@bfc-software/pallet";
import { MapPin, TrendingUp, Users } from "react-feather";
import {
  useTranslation,
  TRANSLATION_NAMESPACE,
} from "@bfc-software/bfc-web-ui/i18n";

import styles from "./home.module.css";
import banner from "/banner.svg";

export const Route = createFileRoute(
  "/$lang/_layout/orgs/$org/_layout/internal/whs/$location/_layout/home",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { t } = useTranslation({
    lang: params.lang,
    namespace: TRANSLATION_NAMESPACE.warehouse,
  });

  return (
    <div className={styles.home}>
      <div className={styles.announcementCard}>
        <Card
          layout="body-only"
          body={
            <>
              <div className={styles.announcementHeader}>
                <Heading
                  className={styles.welcomeHeading}
                  level="2"
                  text={t("newPlatformHeading")}
                />
                <img
                  className={styles.announcementImage}
                  src={banner}
                  alt={t("bfcLogoAlt")}
                />
              </div>

              <div className={styles.releaseSummary}>
                <div>
                  <div className={styles.strengthHeader}>
                    <h4 className={styles.goalHeading}>
                      {t("body.introHeading")}
                    </h4>
                    <MapPin />
                  </div>
                  <p className={styles.introParagraph}>{t("body.intro")}</p>
                </div>

                <div>
                  <div className={styles.strengthHeader}>
                    <h4 className={styles.goalHeading}>
                      {t("body.whatsNewHeading")}
                    </h4>
                    <TrendingUp />
                  </div>
                  <p className={styles.introParagraph}>{t("body.whatsNew")}</p>
                </div>
                <div>
                  <div className={styles.strengthHeader}>
                    <h4 className={styles.goalHeading}>
                      {t("body.closingHeading")}
                    </h4>
                    <Users />
                  </div>
                  <p className={styles.introParagraph}>{t("body.closing")}</p>
                </div>
              </div>
            </>
          }
        />
      </div>
    </div>
  );
}
